@if (canReview()) {
  <app-cta-button variant="light" size="small" (clicked)="onReview()">
    <img cta-prefix src="/public/svgs/preview-w.svg" alt="" class="action-btn-icon" />
    <span cta-label>{{ 'app.admin.dailyFacts.reviewVideo' | translate }}</span>
  </app-cta-button>
} @else {
  <app-cta-button
    variant="light"
    size="small"
    [disabled]="isGenerating()"
    [loading]="isGenerating()"
    (clicked)="onGenerate()"
  >
    <img cta-prefix src="/public/svgs/video-camera.svg" alt="" class="action-btn-icon" />
    <span cta-label>{{ 'app.admin.dailyFacts.generateVideo' | translate }}</span>
  </app-cta-button>
}
